<template>
  <section class="cert-courses">
    <div class="cert-courses-grid">
      <component
        :is="course.href ? 'a' : 'div'"
        v-for="course in courses"
        :key="course.title"
        class="cert-course"
        :href="course.href || null"
        :target="course.href ? '_blank' : null"
        :rel="course.href ? 'noopener noreferrer' : null"
      >
        <div class="cert-course-image-wrap">
          <img
            class="cert-course-image"
            :src="course.image"
            :alt="course.title"
          />
        </div>
        <h3 class="cert-course-title">{{ course.title }}</h3>
        <div class="cert-course-price">{{ course.price }}€</div>
      </component>
    </div>
  </section>
</template>

<script>
import coursePpr from '@/assets/img/certification/course-ppr.jpg';
import courseSmallGroup from '@/assets/img/certification/course-small-group.jpg';
import courseDiscover from '@/assets/img/certification/course-discover.jpg';
import courseRev from '@/assets/img/certification/course-rev.jpg';

export default {
  name: 'CertificationCourses',
  data() {
    return {
      courses: [
        {
          title: 'Prepare Perform Recover (PPR) Certification',
          price: 349,
          image: coursePpr,
          href: 'https://power-plate.inspire360.com/p/prepare-perform-recover-ppr-certification',
        },
        {
          title: 'Power Plate Small Group Training Certification',
          price: 249,
          image: courseSmallGroup,
          href: 'https://power-plate.inspire360.com/p/power-plate-small-group-training-certification',
        },
        {
          title: 'Targeted Vibration Products (TVP)',
          price: 99,
          image: courseDiscover,
        },
        {
          title: 'Introducing the Power Plate REV™',
          price: 99,
          image: courseRev,
          href: 'https://power-plate.inspire360.com/p/rev',
        },
      ],
    };
  },
};
</script>

<style scoped>
.cert-courses {
  padding: 0 16px 40px;
}

@media screen and (min-width: 768px) {
  .cert-courses {
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 60px;
  }
}

@media screen and (min-width: 1024px) {
  .cert-courses {
    padding-left: 60px;
    padding-right: 60px;
    padding-bottom: 80px;
  }
}

@media screen and (min-width: 1440px) {
  .cert-courses {
    padding-left: 80px;
    padding-right: 80px;
  }
}

@media screen and (min-width: 1920px) {
  .cert-courses {
    padding-left: 120px;
    padding-right: 120px;
  }
}

.cert-courses-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

@media screen and (min-width: 768px) {
  .cert-courses-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px;
  }
}

.cert-course {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  color: #000;
  text-decoration: none;
}

.cert-course-image-wrap {
  width: 100%;
  aspect-ratio: 3 / 2;
  border-radius: 24px;
  overflow: hidden;
}

.cert-course-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: filter 0.35s ease;
}

@media (hover: hover) and (pointer: fine) {
  a.cert-course:hover .cert-course-image {
    filter: brightness(1.12);
  }
}

@media (prefers-reduced-motion: reduce) {
  .cert-course-image {
    transition: none;
  }
}

.cert-course-title {
  margin: 16px 0 0;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.3;
  color: #000;
}

@media screen and (min-width: 1024px) {
  .cert-course-title {
    font-size: 20px;
  }
}

@media screen and (min-width: 1440px) {
  .cert-course-title {
    font-size: 22px;
  }
}

.cert-course-price {
  margin-top: 8px;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.2;
  color: #000;
}

@media screen and (min-width: 1024px) {
  .cert-course-price {
    font-size: 20px;
  }
}
</style>
